// import Modal from "../common_modal/Modal";
import Modal from "../common_modal/Modal.jsx";
import { Component } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom/cjs/react-router-dom";

import dict from "../../Data/dict.json";
import { redeem_code } from "../../App/actions/redeemActions";
import { snackbar } from "../../App/actions/snackbarActions";
import { verify_license } from "../../App/actions/license_actions";
import { set_value_properties } from "../../App/actions/propertiesActions";
import { set_value_payment } from "../../App/actions/paymentActions.js";

class RedeemButton extends Component {
  constructor(props) {
    super(props);
    this.state = {
      code: "",
      modal_confirmation: false,
      // notification: {
      //   is_open: false,
      //   status: "error",
      //   message: ""
      // }
    };
  }

  // componentDidUpdate = (prevProps, prevState) => {
  //   const notification_old = prevProps?.notification;
  //   const notification_new = this.state.notification;
  //   if (JSON.stringify(notification_old) !== JSON.stringify(notification_new)) {
  //     this.props.snackbar({
  //       is_open: notification_new?.is_open,
  //       status: notification_new?.status,
  //       message: notification_new?.message
  //     });
  //   }
  // }

  handle_change = (e) => {
    const value = e.target.value;
    this.setState({
      code: value,
    });
  };

  handle_redeem = async () => {
    const language = localStorage.getItem("language") || "ina";
    const { code } = this.state;
    const body = { code, language };
    const result = await this.props.redeem_code(body);
    const { status, data, message } = result;
    const { payment } = this.props.payment || {};

    if (status === 200) {
      this.toggle_modal_confirmation();
      if (!data?.midtrans?.token && !data?.paypal?.links?.length > 0) {
        this.props.snackbar({
          is_open: true,
          status: "success",
          message: "Transaction Successful",
        });
        this.props.set_value_payment({
          key: "payment",
          value: {
            ...payment,
            status: "success",
          },
        });

        this.props.set_value_payment({
          key: "is_able_to_greeting_page",
          value: true,
        });
      } else if (data?.midtrans?.token) {
        this.toggleMidtrans(data?.midtrans?.token, snackbar);
      } else if (data?.paypal?.links?.length > 0) {
        this.props.history.push(`/payment/${data?._id}`);
        this.props.set_value_payment({
          key: "payment",
          value: {
            ...payment,
            status: "success",
          },
        });
        this.props.set_value_payment({
          key: "is_able_to_greeting_page",
          value: true,
        });
      }
    } else {
      this.toggle_modal_confirmation();
      this.props.snackbar({
        is_open: true,
        status: "error",
        message:
          message?.response?.data?.message || "Failed to create transaction",
      });
    }
  };

  toggleMidtrans = (token) => {
    const show_snackbar = this.props.snackbar;
    const { payment } = this.props.payment || {};

    if (token) {
      window.snap.pay(token, {
        onSuccess: (result) => {
          /* You may add your own implementation here */
          show_snackbar({
            is_open: true,
            status: "success",
            message: "Payment Success",
          });
          this.props.verify_license("license_basic");
          this.props.verify_license("license_sini_ai");
          this.props.verify_license("license_sini_data");

          this.props.set_value_payment({
            key: "payment",
            value: {
              ...payment,
              status: "success",
            },
          });

          this.props.set_value_payment({
            key: "is_able_to_greeting_page",
            value: true,
          });
        },
        onPending: (result) => {
          /* You may add your own implementation here */
          // alert("wating your payment!");
        },
        onError: async (result) => {
          /* You may add your own implementation here */
          show_snackbar({
            is_open: true,
            status: "error",
            message: "Payment Failed",
          });
        },
        onClose: () => {
          /* You may add your own implementation here */
          show_snackbar({
            is_open: false,
            status: "info",
            message: "",
          });
          // history.push("/purchase_list");
        },
      });
    }
  };

  toggle_modal_confirmation = () => {
    const { modal_confirmation } = this.state;
    this.setState({
      modal_confirmation: !modal_confirmation,
    });
  };

  is_code_format_valid = () => {
    const { code } = this.state;
    const pattern = /^(?=.*[A-Z\d]).{6}$/;
    return pattern.test(code);
  };

  render() {
    //local storage
    const language = localStorage?.language || this.props.auth.language;

    // props
    const { license_key } = this.props;

    // state
    const { code, modal_confirmation } = this.state;
    const is_valid_code = this.is_code_format_valid(code);

    const modal_confirmation_content = modal_confirmation && (
      <Modal
        modalSize="small"
        isOpen={modal_confirmation}
        onClose={this.toggle_modal_confirmation}
      >
        <main className="box-body flex flex_col gap_10 align_center">
          <label className="bold font_24">
            {dict["Confirmation"][language]}
          </label>
          <p>{dict["Are you sure you want to redeem the code?"][language]}</p>
          <div className="center_perfect gap_10">
            <button
              onClick={this.handle_redeem}
              className="button_inactive background_black rounded_50 text_white padding_5 w_130 h_35"
            >
              {dict["Yes"][language]}
            </button>
            <button
              onClick={this.toggle_modal_confirmation}
              className="button_inactive border rounded_50 border_darkBlue text_darkBlue padding_5 w_130 h_35"
            >
              {dict["No"][language]}
            </button>
          </div>
        </main>
      </Modal>
    );

    return (
      <main className="center_perfect marginTop_50 h_full">
        {license_key !== "license_3" && (
          <div className="redeem_field center_perfect">
            <input
              className="border_none font_16 bold text_black"
              type="text"
              placeholder="Input Code..."
              value={code}
              onChange={this.handle_change}
            />
            {is_valid_code && (
              <button
                style={{
                  background: "#006ABA",
                }}
                className="button_inactive rounded_5 text_white margin_y_5 w_100 padding_y_15"
                onClick={this.toggle_modal_confirmation}
              >
                Redeem
              </button>
            )}
          </div>
        )}
        {modal_confirmation_content}
      </main>
    );
  }
}

const mapStateToProps = (state) => ({
  auth: state.auth,
  snackbar_props: state.snackbar,
  payment: state.payment,
});

export default withRouter(
  connect(mapStateToProps, {
    redeem_code,
    snackbar,
    verify_license,
    set_value_properties,
    set_value_payment,
  })(RedeemButton),
);
